import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlSalenoteApproveDiscount } from './connectionData.tsx'

const useSalenoteDiscountApprove = () => {
  const [errorSalenoteDiscountApprove, setErrorSalenoteDiscountApprove] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const salenoteDiscountApprove = async (_id: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSalenoteApproveDiscount()
      const res = await customPost<{ message: string }>(apiUrl, { _id, by })
      setErrorSalenoteDiscountApprove(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenoteDiscountApprove(err)
      } else {
        setErrorSalenoteDiscountApprove(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorSalenoteDiscountApprove, loading, salenoteDiscountApprove }
}
export default useSalenoteDiscountApprove
